// User-provided API keys and preferences, stored locally in the browser.
// Keys never leave the device except as request params to our own backend
// (OCM key) or to Google's Maps script (Street View key).

const KEYS = {
  ocmKey: "vsp_ocm_key",
  googleKey: "vsp_google_maps_key",
  ocmPriority: "vsp_ocm_priority", // OCM first when point is outside France
};

function read(key, fallback = "") {
  try {
    const v = localStorage.getItem(key);
    return v == null ? fallback : v;
  } catch (e) {
    console.debug("[settings] localStorage read failed:", key, e);
    return fallback;
  }
}

function write(key, value) {
  try {
    if (value === "" || value == null) localStorage.removeItem(key);
    else localStorage.setItem(key, String(value));
  } catch (e) {
    console.debug("[settings] localStorage write failed (quota/privacy mode):", key, e);
  }
}

export function getOcmKey() {
  return read(KEYS.ocmKey).trim();
}

export function getGoogleMapsKey() {
  // Fall back to a build-time env var when the user hasn't entered a key.
  return read(KEYS.googleKey).trim() || (process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "").trim();
}

export function getOcmPriority() {
  return read(KEYS.ocmPriority) === "on";
}

export function getSettings() {
  return {
    ocmKey: read(KEYS.ocmKey).trim(),
    googleKey: read(KEYS.googleKey).trim(),
    ocmPriority: getOcmPriority(),
  };
}

export function saveSettings({ ocmKey, googleKey, ocmPriority }) {
  if (ocmKey !== undefined) write(KEYS.ocmKey, ocmKey.trim());
  if (googleKey !== undefined) write(KEYS.googleKey, googleKey.trim());
  if (ocmPriority !== undefined) write(KEYS.ocmPriority, ocmPriority ? "on" : "");
}
